import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./ScrollToTop";

import HomePage from "./HomePage";
import AboutPage from "./AboutPage";
import CollegeDetail from "./pages/CollegeDetail";
import ApplyNow from "./pages/ApplyNow";
import ContactUs from "./pages/ContactUs";
import Applyuit from "./components/layout/Applyuit";
import WhatsAppButton from './components/common/WhatsAppButton'; // ✅ Add this import

import BackButton from "./components/common/BackButton";

function App() {
  return (
    <>
    
      <BackButton />
      <ScrollToTop />

      <HelmetProvider>
        <Routes>

          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/college/:slug" element={<CollegeDetail />} />
          <Route path="/apply" element={<ApplyNow />} />
          <Route path="/apply-now" element={<ApplyNow />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/applyuit" element={<Applyuit />} />
        </Routes>
                  <WhatsAppButton />

      </HelmetProvider>
    </>
  );
}

export default App;
